module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/contracts/contracts.component.html
// module id = ./src/app/components/dashboard/contracts/contracts.component.html
// module chunks = main